import { render, staticRenderFns } from "./SendMessageOtherUserDetailTab.vue?vue&type=template&id=6ee7a35c&scoped=true&lang=pug"
import script from "./SendMessageOtherUserDetailTab.vue?vue&type=script&lang=ts"
export * from "./SendMessageOtherUserDetailTab.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageOtherUserDetailTab.vue?vue&type=style&index=0&id=6ee7a35c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee7a35c",
  null
  
)

export default component.exports